export default __webpack_public_path__ + "static/media/StrRev.7c0fc5ba.svg";